import React from 'react';
import { Category, Answer, CategoryResponse } from '../types';
import QuestionCard from './QuestionCard';

interface QuestionnaireSectionProps {
  category: Category;
  responses: CategoryResponse;
  onAnswerChange: (questionId: string, answer: Answer) => void;
}

const QuestionnaireSection: React.FC<QuestionnaireSectionProps> = ({ 
  category, 
  responses, 
  onAnswerChange 
}) => {
  // Get part A question
  const partAQuestion = category.questions.find(q => q.part === 'A');
  // Get part B question
  const partBQuestion = category.questions.find(q => q.part === 'B');
  // Get part C question
  const partCQuestion = category.questions.find(q => q.part === 'C');

  // Determine if part B should be shown (only if part A was answered Yes)
  const showPartB = responses.responses.partA === 'Yes';
  
  // Determine if part C should be shown (only if both part A and B were answered Yes)
  const showPartC = responses.responses.partA === 'Yes' && responses.responses.partB === 'Yes';

  return (
    <div className="mb-8" style={{ WebkitOverflowScrolling: 'touch', touchAction: 'pan-y' }}>
      <div className="bg-primary/10 p-4 rounded-md mb-4">
        <h2 className="text-xl font-semibold text-foreground">{category.title}</h2>
      </div>
      
      {partAQuestion && (
        <div className="mb-4">
          {/* <h3 className="text-md font-medium text-gray-700 mb-2">Part A (Level 1)</h3> */}
          <QuestionCard
            question={partAQuestion}
            answer={responses.responses.partA}
            onChange={(answer) => onAnswerChange(partAQuestion.id, answer)}
          />
        </div>
      )}
      
      {showPartB && partBQuestion && (
        <div className="mb-4">
          {/* <h3 className="text-md font-medium text-gray-700 mb-2">Part B (Level 2)</h3> */}
          <QuestionCard
            question={partBQuestion}
            answer={responses.responses.partB}
            onChange={(answer) => onAnswerChange(partBQuestion.id, answer)}
          />
        </div>
      )}
      
      {showPartC && partCQuestion && (
        <div className="mb-4">
          {/* <h3 className="text-md font-medium text-gray-700 mb-2">Part C (Level 3)</h3> */}
          <QuestionCard
            question={partCQuestion}
            answer={responses.responses.partC}
            onChange={(answer) => onAnswerChange(partCQuestion.id, answer)}
          />
        </div>
      )}
    </div>
  );
};

export default QuestionnaireSection;
